//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React, { useMemo, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { lighten, invert } from 'polished';
import {Snackbar } from '@mui/material';
import {Alert} from '@mui/material';
//  -- Components ---------------------
import { Drawer, Col, Tooltip } from 'antd';
import { CopyAllOutlined, Delete } from '@mui/icons-material';

//  -- Constants ----------------------
import COLOR from 'utils/constants/color';

//  -- Features -----------------------
import ActivityForm from 'features/forms/Activity';
import QuizForm from 'features/forms/Quiz';

//  -- Thunks -------------------------
import { handleCreateClassActivity, handleCreateClassActivityGoogle, handleCreateClassActivitySchoology } from 'store/classActivities/thunks';
import { handleCreateClassQuiz, handleCreateClassQuizGoogle, handleCreateClassQuizSchoology } from 'store/classQuizzes/thunks';
import { handleListClassQuizzes } from 'store/classQuizzes/thunks';
import { find, filter, map, get, omit } from 'lodash';
import { validateQuizeActivityData } from 'utils/methods/createQuizeActivityValidator';
import { useEffect } from 'react';
import AssignmentForm from 'features/forms/AssignmentForm';
import { IconButton } from '@mui/material';
import { DeleteModal } from 'components/Dialog';
import {
  handleCreateCustomAssignment,
  handleDeleteCustomAssignment,
  handleGetAssignmentStatus,
  handleUnhareToMe,
} from 'store/activities/thunks';
import CloneActivityToPageModal from 'components/CloneActivityToPageModal';


import { useClassUsers, useUserClasses, useUsersByClass } from 'store/userClasses/selectors';
import { handleCreateGoogleAssignment } from 'store/googleClassRoom/thunks';
import { handleCreateCanvasAssignment, handleCreateCanvasAssignmentDeepLink, handleCreatePendingActivity } from 'store/canvas/thunks';
import AssignableNotificationShare from './AssignableNotificationShare';
import { useAllDistrictTeacher } from 'store/users/selectors';
import SharedAndAssignedTask from './SharedAndAssigned';
import ExamsSharedAndAssignedTask from './ExamsSharedAndAssigned';
import AssignmentAi from 'utils/assets/images/Assignment_ai.png';
import { useExams } from 'store/exams/selectors';
import { useActivities } from 'store/activities/selectors';
import { useQuizzes } from 'store/quizzes/selectors';
import PrintPage from './PrintPage';
import { useAiAnswerView } from 'store/main_book_popup/selectors';
import { useCollectionNotification } from 'utils/methods/firebaseNotification';
import { v4 } from 'uuid';
import moment from 'moment-timezone';
import { handleCreateAssignmentToSchoology } from 'store/schoology/thunks';
import * as Sentry from '@sentry/react';
import usePopUpAtOnce from './hooks/usePopUpAtOnce';
import { useAlert } from './UI/alertSakeBar/alertProvider';
import useBookCollection from './hooks/books/useBookCollection';
import { shouldUseDeepLinking, getDeepLinkInfo } from 'utils/deepLinkHelper';

import { imageFetch, imageFetchFromPodcast, isVideo } from 'utils/lib/ebookHelper';
import { useAllBook } from 'store/books/selectors';
import { useResources } from 'store/resources/selectors';
import { usePageCover } from './hooks/pageCover/pageCover';
import trashIconSvg from '../utils/assets/images/trashIcon.svg';
import customEditSvg from '../utils/assets/images/customEdit.svg';
import titleIconSvg from '../utils/assets/images/titleIcon.svg';
import lastSubSvg from '../utils/assets/images/last-sub.svg';
import statusSvg from '../utils/assets/images/status.svg';
import assignerSvg from '../utils/assets/images/assigner.svg';
import eyeBtnSvg from '../utils/assets/images/eyeBtn.svg';
import nonAssignSvg from '../utils/assets/images/non-assign.svg';
import assignSvg from '../utils/assets/images/assign.svg';
import dummyImage2Svg from '../utils/assets/images/dummyImage2.svg';
import dummyImageSvg from '../utils/assets/images/dummyImage.svg';
import SentryWrap from 'components/Sentry';
import ShowStoryBtn from './ShowStoryButton';
import SpinLoader from './Loader/SpinLoader';
import WorksheetAssignment from 'modules/workSheet/WorksheetAssignment';
import { useGetMaskId } from './hooks/maskId/useGetMaskId';
import { articleLevelCover, SoyHistoriasNew } from 'utils/assets/images';
import { useIsTab, useMobileDetect } from 'containers/chat/hooks';
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const getSystemTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    return null;
  }
}

const Row = styled.div`
  align-items: ${(p) => p.align || 'center'};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 16px;
  width: 100%;

  &:last-child {
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 0px;
  }
`;

const Text = styled.span`
  color: ${COLOR.black500};
  font-size: 11px;
  margin-top: 2px;
  text-align: left;
`;

const TextLarge = styled(Text)`
  // color: #3D5F8F;
  color: black;
  font-size: 13px;
  font-weight: 600;
  margin-right: 4px;
`;

const Title = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  text-align: left;
`;

const Wrapper = styled.button`
  // background-color: ${(p) => p.bgColor ? p.bgColor : lighten(0.55, '#3D5F8F')};
  // border: 2px solid ${(p) =>  p.borderColor ? lighten(0.2, invert(p.bgColor)) : lighten(0.3, '#3D5F8F')};

  border: 2px solid ${(p) =>  p.bgColor ? p.bgColor : p.isGeneratedTest ? '#2C3A47' : '#88ADE2'};
  color: #3d5f8f;
  // cursor: ${(p) => (p.disabled ? 'no-drop' : 'pointer')};
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 6px;
  outline: none;
  padding: 12px 12px 10px;
  transition: all 300ms ease;
  width: 100%;
  border-radius: 11px;
  margin-top: 16px;
  background: #fff;
  position: relative;
  padding-left: 30px;
  min-height: 195px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &::before {
    width: 20px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    background: ${(p) =>
      (p.bgColor && !p.isExam && !p.isUnitExam)
        ? '#88ADE2'
        : p.bgColor
          ? p.bgColor
          : p.isGeneratedTest
            ? '#2C3A47'
            : '#88ADE2'};
    content: "";
    border-radius: 8px 0px 0px 8px;
  }
  // &:hover {border: 2px solid ${(p) =>  p.bgColor ? p.bgColor : '#1837ED'};}
  // &:hover&::before {background: ${(p) =>  p.bgColor ? p.bgColor : '#1837ED'};}
`;

/* <-------------------------New-exame-design css-------------------------> */
const ExamAssignmentWrapper = styled.div`
  
  // background-color: ${(p) => p.bgColor ? p.bgColor : lighten(0.55, '#3D5F8F')};
  border: 2px solid ${(p) =>  p.isUnitExam ? '#ffa947' :p.bgColor ? p.bgColor : '#88ADE2'};
  border-radius: 11px;
  color: ${COLOR.green100};
  // cursor: ${(p) => (p.disabled ? 'no-drop' : 'pointer')};
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 16px;
  outline: none;
  padding: 12px 12px 10px;
  transition: all 300ms ease;
  width: 100%;
  background: #fff;
  position: relative;
  padding-left: 30px;
  min-height: 195px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &::before {
    width: 20px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    // background: ${(p) =>  p.bgColor ? p.bgColor : p.isUnitExam ? '#CCE4E4' : '#88ADE2'};
    content: "";
    border-radius: 8px 0px 0px 8px;
  }
  // &:hover {border: 2px solid ${(p) =>  p.bgColor ? p.bgColor : '#1837ED'};}
  // &:hover&::before {background: ${(p) =>  p.bgColor ? p.bgColor : '#1837ED'};}
  // &:hover { background-color: ${(p) => p.hoverColor ? p.hoverColor : lighten(0.5, '#3D5F8F')} }
`;

const Rows = styled.div`
  align-items: ${(p) => p.align || 'center'};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 16px;
  width: 100%;

  &:last-child {
    align-items: flex-end;
    justify-content: flex-end;
    margin-bottom: 0px;
  }
`;

/* <-------------------------End New-exame-design css-------------------------> */

const BookDescRow = styled(Row)`
  font-size: 10px;
  padding-left: 30px;
  margin-top: -15px;
`;


const AssignableNotification = ({
  assignment,
  currentClass,
  currentUser,
  booksAllList,
  onPreviewCick = () => null,
  chapter,
  from = "",
  extensionActivityData ={},
  worksheetData = [],
}) => {
  const isTablate = useIsTab();
  const dispatch = useDispatch();
  const bookAllList = useAllBook();
  const resources = useResources();
  const { invokeAiAnswerView } = useAiAnswerView();
  const classUsers = useClassUsers()
  const usersByClass = useUsersByClass()
  const { createNotificationAssignment, createBatchNotificationAssignment} = useCollectionNotification();
  const activities = useActivities();
  const quizzes = useQuizzes();
  const [activityDrawer, toggleActivityDrawer] = useState(false);
  const [quizDrawer, toggleQuizDrawer] = useState(false);
  const [activityData, setActivityData] = useState({});
  const [quizData, setQuizData] = useState({});
  const [dataLoading, setDataLoading] = useState(false);
  const [durationSection, setDurationSection] = useState(false);
  const isReviewAccount = currentUser?.reviewAccount || false;
  const [openReviewDialog, setReviewDialog] = React.useState({
    open: false,
    message: '',
  });
  const [fetchSelectedRubric,setFetchRubricId] = useState(null);
  const bookid =  assignment?.chapter ||  assignment?.bookId ;
  const isAssignmentBook = find(
    booksAllList,
    (e) => e.id == bookid
  )?.quizAssessment;
  const colorCode = get(assignment, 'colorCode');
  const bookDescription = get(assignment, 'bookDescription');
  const isUnitExam = get(assignment, 'is_unit_exam');
  const assignment_chapter = get(assignment, "chapter")
  const assignment_page =  get(assignment, "page")
  
  const assignmentColor = isAssignmentBook
    ? lighten(0.3, COLOR.orange100)
    : colorCode;
  const exams = useExams();
  const examBookIds = exams?.flatMap((entry) =>
    entry.exams.map((exam) => `${exam.bookId}`)
  );
  const is_exam = !!assignment?.is_exam
  const isExam = examBookIds.includes(chapter) || is_exam || isUnitExam;
  const isGeneratedTest = Boolean(assignment?.generated_test);
  const [editCustomAssignmentData, setEditCustomAssignmentData] =
    useState(null);
  const [editCustomAssignmentModal, setEditCustomAssignmentModal] =
    useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [Assignloader, setAssignLoader] = useState(false);
  const [pendingActivityLoading, setPendingActivityLoading] = useState(false);
  const [cloneToPageOpen, setCloneToPageOpen] = useState(false);
  const [deepLinkConfig, setDeepLinkConfig] = useState(null);
  const userClasses = useUserClasses();
  const allDistrictTeacher = useAllDistrictTeacher();
  const pageCover = usePageCover({ assignmentData: assignment });
  const {maskId} = useGetMaskId(from, assignment_page, assignment_chapter);
  const isExternalToolMode = shouldUseDeepLinking();
  const modalSrc = useMemo(() => pageCover? pageCover : isVideo(assignment_chapter, resources) ? imageFetchFromPodcast(assignment_chapter, resources) : imageFetch(bookAllList, assignment_chapter, assignment_page),[resources,bookAllList,chapter, assignment_page,assignment?.id, pageCover]);
  const is_soy_story = useMemo(() => activityData && ((typeof activityData.storyInstruction == "string" && activityData.storyInstruction.length > 0) || (activityData?.data && typeof activityData?.data.storyInstruction == "string" && activityData?.data.storyInstruction.length > 0)), [activityData])
  const is_article_level = useMemo(() => activityData && ((typeof activityData.article_level_id == "string" && activityData.article_level_id.length > 0) || (activityData?.data && typeof activityData?.data.article_level_id == "string" && activityData?.data.article_level_id.length > 0)), [activityData])
  const AssignmentShareList =
    assignment?.share_list?.length > 0 ? assignment?.share_list : [];
  const fetchShareBy =
    find(allDistrictTeacher, (obj) => obj.id === assignment?.share_by) ?? {};
  const filterClassUsers = filter(classUsers, (user) => user?.role !== 'teacher' && user?.active === true).map(user => user.id);
  const {checkPopUpAtOnce, updatePopUpAtOnce} = usePopUpAtOnce();
  const showAlert = useAlert();
  const  {nonAssignableBookIds = [],hiddenBookGroupBookId = [],hiddenBookId=[]} = useBookCollection();
  
  const isBookNotAssignable = useMemo(() => {
    if(nonAssignableBookIds?.includes(Number(bookid))){
      return true;
    }
    return false;
  }, [currentClass, nonAssignableBookIds, bookid])

  const isBookHidden = useMemo(() => {
    if(hiddenBookId?.includes(Number(bookid)) || hiddenBookGroupBookId?.includes(Number(bookid))){
      return true;
    }
    return false;
  }, [currentClass, hiddenBookId, hiddenBookGroupBookId, bookid])
  const storyInstructionView = assignment?.storyInstruction || assignment?.data?.storyInstruction;
  const showCopyToBookPage =
    assignment?.typeId === 'activity' ||
    assignment?.typeId === 'quiz' ||
    assignment?.typeId === 'worksheet';
  const copyToBookPageTooltipTitle =
    assignment?.typeId === 'worksheet'
      ? 'Copy grammar drill to another book/page'
      : assignment?.type === 'custom'
        ? 'Copy or move to another book/page'
        : 'Copy to another book/page';

  const sendNotifications = async (notificationData) => {
    try {
      await createNotificationAssignment(notificationData, usersByClass);
    } catch (error) {
      console.log(error, 'error');
      Sentry.captureException(`139 Error creating share notification: ${error}`);
    }
  };

  const sendBatchNotifications = async (notificationsArray) => {
    if (!notificationsArray || notificationsArray.length === 0) {
      return;
    }
    try {
      await createBatchNotificationAssignment(notificationsArray, usersByClass);
    } catch (error) {
      console.log(error, 'error in batch notifications');
      Sentry.captureException(`Error sending batch notifications: ${error}`);
    }
  };

  const handleForDistrictAdmin = () =>{
    if (currentUser.role === 'admin') {
      setReviewDialog({ open: true, message: 'Please login as teacher!' });
      return true;
    }
    return false;
  }

  const isScheduledToday = (scheduleAt) => {
    return moment(scheduleAt).isSame(moment(), 'day');
  };

  const fetchAlreadyAssignedClassIdsByAssignment = async (assignments) => {
    const result = {};
    await Promise.all(
      assignments.map(async (assignment) => {
        try {
          const status = await handleGetAssignmentStatus(assignment.id, currentUser?.id);
          const ids = Array.isArray(status) ? map(status, (k) => k.classId).filter(Boolean) : [];
          result[assignment.id] = ids;
        } catch {
          result[assignment.id] = [];
        }
      })
    );
    return result;
  };

  const filterPayloadForIntegrationCreate = (payload, alreadyAssignedByAssignmentId = {}) => {
    const selectedAssignments = Array.isArray(payload?.selectedAssignments) ? payload.selectedAssignments : [];
    const filteredSelectedAssignments = selectedAssignments.map((assignment) => {
      const alreadyAssignedClassIds = alreadyAssignedByAssignmentId[assignment?.id] || [];
      const classes = Array.isArray(assignment?.classes)
        ? assignment.classes.filter(
          (cls) => cls && !alreadyAssignedClassIds.some((id) => id == cls?.id)
        )
        : [];
      return {
        ...assignment,
        classes
      };
    });

    const mainAssignmentId = payload?.activityId || payload?.quizId || payload?.id;
    const mainAssignment = find(filteredSelectedAssignments, (assignment) => assignment?.id == mainAssignmentId);
    const classes = Array.isArray(mainAssignment?.classes)
      ? mainAssignment.classes
      : Array.isArray(payload?.classes)
        ? payload.classes
        : [];

    return {
      ...payload,
      classes,
      selectedAssignments: filteredSelectedAssignments
    };
  };
  

  const createActivity = async (e) => {
    e.preventDefault();
    
    const selectedAssignments = activityData.selectedAssignments || [];
    const allAssignments = [...activities, ...quizzes];
    
    const selectedAssignmentsAsObjects = selectedAssignments
    .map(assignmentId => {
      const assignmentInfo = allAssignments.find(act => act.id === assignmentId);
      if (!assignmentInfo) return null;
  
      const updatedClasses = activityData.classes?.map(cls => {
        const userClass = userClasses.find(user => user.id === cls.id);
        return userClass
          ? { ...cls, googleClassId: userClass.googleId }
          : cls;
      }) || [];

      const isMainAssignment = assignmentInfo.id === activityData.id;
  
      return {
        classId: currentClass.id,
        ...activityData,
        id: assignmentInfo.id,
        activityId: assignmentInfo.typeId === 'activity' ? assignmentInfo.id : null,
        quizId: assignmentInfo.typeId === 'quiz' ? assignmentInfo.id : null,
        rubrics_id: fetchSelectedRubric,
        assignFrom: from === "extensionActivity" ? extensionActivityData : null,
        bookId: assignmentInfo.chapter || activityData.chapter,
        page: assignmentInfo.page || activityData.page,
        dueDate: activityData.dueDate,
        retakes: activityData.retakes,
        scheduleAt: activityData.scheduleAt,
        lateDate: activityData.lateDate,
        classes: updatedClasses,
        shuffled: activityData.shuffled,
        displayName: isMainAssignment ? activityData.displayName : (assignmentInfo.displayName || activityData.displayName),
        no_sync: activityData.no_sync || false,
        timeDuration: activityData.timeDuration,
        ai_grading_config: activityData.ai_grading_config,
        weightage: activityData.weightage,
        typeId: assignmentInfo.typeId,
      };
    })
    .filter(Boolean);

    if (selectedAssignmentsAsObjects.length === 0) {
      setDataLoading(false);
      console.log("No valid assignments found");
      return;
    }

    const alreadyAssignedByAssignmentId = await fetchAlreadyAssignedClassIdsByAssignment(selectedAssignmentsAsObjects);

    const book_info = {
      locate_url: window.location.pathname + window.location.search,
      mask_id: maskId,
      page_cover_url: is_article_level ? articleLevelCover : is_soy_story ? SoyHistoriasNew : pageCover,
    }
    let actvityDataForCreate = {
      classId: currentClass.id,
      ...activityData,
      activityId: activityData.id,
      rubrics_id: fetchSelectedRubric,
      selectedAssignments: selectedAssignmentsAsObjects,
      ...(from === "extensionActivity" ? { assignFrom: extensionActivityData } : {assignFrom: null}),
      meta_data: {
        book_info: book_info
      }
    };

    const notificationsData = selectedAssignmentsAsObjects.map((assignment) => {
      const alreadyAssignedClassIds = alreadyAssignedByAssignmentId[assignment.id] || [];
      const classesForNotification = get(assignment, 'classes', []).filter(
        (cls) => !alreadyAssignedClassIds.some((id) => id == cls?.id)
      );
      const configAssignment = get(assignment, 'data.config_assignment') || get(assignment, 'config_assignment') || get(activityData, 'data.config_assignment') || get(activityData, 'config_assignment');
      const isEngageAssignment = configAssignment?.isFrom === 'engagement';  
      return {
        id: v4(),
        classId: get(currentClass, 'id', ''),
        displayName: assignment.displayName,
        senderId: get(currentUser, 'id', ''),
        receiversId: filterClassUsers,
        modified: moment().toISOString(),
        data: {
          chapter: assignment.chapter || get(activityData, 'chapter', ''),
          page: assignment.page || get(activityData, 'page', ''),
          id: assignment.id,
          scheduleAt: activityData?.scheduleAt,
          classes: classesForNotification.map((cls) => ({
            id: cls?.id,
            users: cls?.users?.length > 0 ?  cls?.users : null
          })),
          meta_data: {
            book_info: book_info
          },
          ...(from === "extensionActivity" ? { assignfrom: extensionActivityData } : {assignfrom: null}),
          ...(isEngageAssignment && configAssignment ? { config_assignment: configAssignment } : {}),
        },
        message: `Your teacher Assigned this Activity`,
        type: 'create_activity',
        is_soy_story: is_soy_story ? is_soy_story : false,
        userSeen: []
      };
    });
    if (!actvityDataForCreate.bookId)
      actvityDataForCreate.bookId = activityData.chapter;

    let { isValid, reason } = validateQuizeActivityData(
      actvityDataForCreate,
      'activity'
    );
    if (!isValid) {
      setDataLoading(false);
      return;
    }
    
    setDataLoading(true);
    if (deepLinkConfig) {
      try {
        const pendingActivityData = {
          assignment_id: activityData.id,
          assignment_type: 'activity',
          display_name: activityData.displayName,
          chapter: activityData.chapter || activityData.bookId,
          page: activityData.page,
          class_id: currentClass.id,
          user_id: currentUser.id,
          canvas_auth_id: currentUser.canvas_auth_id,
          id_token: deepLinkConfig.id_token,
          state: deepLinkConfig.state,
          assignment_data: {
            ...activityData,
            redirect_path: deepLinkConfig.redirect_path,
            redirect_class_id: deepLinkConfig.redirect_class_id,
            redirect_assignment_id: deepLinkConfig.redirect_assignment_id
          }
        };
        const result = await dispatch(handleCreatePendingActivity(pendingActivityData));
        if (result && (result.success || result.data)) {
          const internalAssignmentId = result.data?.id ?? result.data?.internal_assignment_id;
          const assignmentData = {
            ...activityData,
            id: activityData.id,
            assignmentId: activityData.id,
            displayName: activityData.displayName,
            name: activityData.displayName,
            title: activityData.displayName,
            chapter: activityData.chapter || activityData.bookId,
            page: activityData.page,
            classId: currentClass.id,
            type: 'activity',
            canvas_course_id: currentClass.canvas_course_id,
            canvas_section_id: currentClass.canvas_id,
            internal_assignment_id: internalAssignmentId
          };
          const deepLinkAssignmentData = {
            ...activityData,
            redirect_path: deepLinkConfig.redirect_path,
            redirect_class_id: deepLinkConfig.redirect_class_id,
            redirect_assignment_id: deepLinkConfig.redirect_assignment_id
          };
          const deepLinkResult = await dispatch(handleCreateCanvasAssignmentDeepLink(
            currentUser.canvas_id,
            [assignmentData],
            currentUser.canvas_auth_id,
            deepLinkAssignmentData
          ));
          if (deepLinkResult && deepLinkResult.isDeepLinking) {
            showAlert("Activity selected and linked to Canvas.", "success");
          } else {
            showAlert("Pending activity created. You can sync it later.", "success");
          }
        } else {
          showAlert("Failed to create pending activity. Please try again.", "error");
        }
      } catch (error) {
        console.error('Error creating pending activity:', error);
        showAlert("Error creating pending activity. Please try again.", "error");
      }
      toggleActivityDrawer(false);
      setDataLoading(false);
      setActivityData({});
      return;
    }
    const hasMultipleAssignments = actvityDataForCreate.selectedAssignments && actvityDataForCreate.selectedAssignments.length > 1;
    const integrationActivityDataForCreate = filterPayloadForIntegrationCreate(
      actvityDataForCreate,
      alreadyAssignedByAssignmentId
    );
    if (currentUser.googleId) {
      await dispatch(handleCreateClassActivityGoogle(actvityDataForCreate, currentUser.googleId));
    } else if (currentUser.schoologyid && hasMultipleAssignments) {
      await dispatch(handleCreateClassActivitySchoology(integrationActivityDataForCreate, currentUser.schoologyid));
    } else {
      const sAssignmentData = await createAssignmetToSchoologyMultipleClass(integrationActivityDataForCreate);
      if (sAssignmentData && sAssignmentData.length > 0) {
        actvityDataForCreate.sAssignmentData = sAssignmentData;
        actvityDataForCreate?.selectedAssignments?.forEach((assignment) => {
          const assignmentSchoologyData = sAssignmentData.filter((schoologyItem) => schoologyItem.assignmentId === assignment.id);
          assignment.sAssignmentData = assignmentSchoologyData;
        });
      }
      
      const canvasData = await createAssignmetToCanvasMultipleClass(integrationActivityDataForCreate);
      if (canvasData && canvasData.length > 0) {
        actvityDataForCreate.canvasData = canvasData;
      }
      
      if (!currentUser.googleId) {
        await dispatch(handleCreateClassActivity(actvityDataForCreate));
      }
    }
    if (isScheduledToday(activityData?.scheduleAt)) {
      await sendBatchNotifications(notificationsData);
    }
    toggleActivityDrawer(false);
    setDataLoading(false);
    setActivityData({});
  };
  
  useEffect(() => {
    if (!quizDrawer && !activityDrawer) {
      setQuizData({});
      setActivityData({});
      setDataLoading(false);
      setDurationSection(false);
      setDeepLinkConfig(null);
    }
  }, [quizDrawer, activityDrawer]);

  const createQuiz = async (e) => {
    e.preventDefault();
    
    const selectedAssignments = quizData.selectedAssignments || [];
    const allAssignments = [...activities, ...quizzes];

    
    const selectedAssignmentsAsObjects = selectedAssignments.map(assignmentId => {
      const assignmentInfo = allAssignments.find(act => act.id === assignmentId);
      const isMainAssignment = assignmentInfo?.id === quizData?.id;
      const updatedClasses = quizData.classes?.map(cls => {
        const userClass = userClasses.find(user => user.id === cls.id);
        return userClass
          ? { ...cls, googleClassId: userClass.googleId }
          : cls;
      }) || [];
      if (assignmentInfo) {        
        return {
          classId: currentClass.id,
          ...quizData,
          id: assignmentInfo.id,
          page: assignmentInfo.page || quizData.page,
          quizId: assignmentInfo.typeId === 'quiz' ? assignmentInfo.id : null,
          activityId: assignmentInfo.typeId === 'activity' ? assignmentInfo.id : null,
          rubrics_id: fetchSelectedRubric,
          ...(from === "extensionActivity" ? { assignFrom: extensionActivityData } : {assignFrom: null}),
          bookId: assignmentInfo.chapter || quizData.chapter,
          dueDate: quizData.dueDate,
          retakes: quizData.retakes,
          scheduleAt: quizData.scheduleAt,
          lateDate: quizData.lateDate,
          classes: updatedClasses || [],
          displayName: isMainAssignment ? quizData.displayName : (assignmentInfo.displayName || quizData.displayName),
          no_sync: quizData.no_sync || false,
          shuffled: quizData.shuffled,
          timeDuration: quizData.timeDuration,
          ai_grading_config: quizData.ai_grading_config,
          weightage: quizData.weightage,
          typeId: assignmentInfo.typeId,
        };
      }
      return null;
    }).filter(Boolean);

    if (selectedAssignmentsAsObjects.length === 0) {
      setDataLoading(false);
      console.log("No valid assignments found");
      return;
    }

    const alreadyAssignedByAssignmentId = await fetchAlreadyAssignedClassIdsByAssignment(selectedAssignmentsAsObjects);

    let studentsSelected = [];
    const book_info = {
      locate_url: window.location.pathname + window.location.search,
      mask_id: maskId,
      page_cover_url: is_article_level ? articleLevelCover : is_soy_story ? SoyHistoriasNew : pageCover,
    }
    let quizDataForCreate = {
      classId: currentClass.id,
      ...quizData,
      quizId: quizData.id,
      studentsSelected: studentsSelected,
      rubrics_id:  fetchSelectedRubric,
      selectedAssignments: selectedAssignmentsAsObjects,
      ...(from === "extensionActivity" ? { assignFrom: extensionActivityData } : {assignFrom: null}),
      meta_data: {
        book_info: book_info
      }
    };

    const notificationsData = selectedAssignmentsAsObjects.map((assignment) => {
      const alreadyAssignedClassIds = alreadyAssignedByAssignmentId[assignment.id] || [];
      const classesForNotification = get(assignment, 'classes', []).filter(
        (cls) => !alreadyAssignedClassIds.some((id) => id == cls?.id)
      );
      const configAssignment = get(assignment, 'data.config_assignment') || get(assignment, 'config_assignment') || get(quizData, 'data.config_assignment') || get(quizData, 'config_assignment');
      const isEngageAssignment = configAssignment?.isFrom === 'engagement';
      return {
        id: v4(),
        classId: get(currentClass, 'id', ''),
        displayName: assignment.displayName,
        senderId: get(currentUser, 'id', ''),
        receiversId: filterClassUsers,
        modified: moment().toISOString(),
        data: {
          chapter: assignment.chapter || get(quizData, 'chapter', ''),
          page: assignment.page || get(quizData, 'page', ''),
          id: assignment.id,
          scheduleAt: quizData?.scheduleAt,
          classes: classesForNotification.map((cls) => ({
            id: cls?.id,
            users: cls?.users?.length > 0 ?  cls?.users : null
          })),
          ...(from === "extensionActivity" ? { assignfrom: extensionActivityData } : {assignfrom: null}),
          ...(isEngageAssignment && configAssignment ? { config_assignment: configAssignment } : {}),
          meta_data: {
            book_info: book_info
          }
        },
        message: `Your teacher Assigned this Quiz`,
        type: 'create_quiz',
        userSeen: []
      };
    });
    if (!quizDataForCreate.bookId) quizDataForCreate.bookId = quizData.chapter;
    
    let { isValid, reason } = validateQuizeActivityData(
      quizDataForCreate,
      'quiz'
    );
    if (!isValid) {
      setDataLoading(false);
      return;
    }
    setDataLoading(true);
    if (deepLinkConfig) {
      try {
        const pendingActivityData = {
          assignment_id: quizData.id,
          assignment_type: 'quiz',
          display_name: quizData.displayName,
          chapter: quizData.chapter || quizData.bookId,
          page: quizData.page,
          class_id: currentClass.id,
          user_id: currentUser.id,
          canvas_auth_id: currentUser.canvas_auth_id,
          id_token: deepLinkConfig.id_token,
          state: deepLinkConfig.state,
          assignment_data: {
            ...quizData,
            redirect_path: deepLinkConfig.redirect_path,
            redirect_class_id: deepLinkConfig.redirect_class_id,
            redirect_assignment_id: deepLinkConfig.redirect_assignment_id
          }
        };
        const result = await dispatch(handleCreatePendingActivity(pendingActivityData));
        if (result && (result.success || result.data)) {
          const internalAssignmentId = result.data?.id ?? result.data?.internal_assignment_id;
          const assignmentData = {
            ...quizData,
            id: quizData.id,
            assignmentId: quizData.id,
            displayName: quizData.displayName,
            name: quizData.displayName,
            title: quizData.displayName,
            chapter: quizData.chapter || quizData.bookId,
            page: quizData.page,
            classId: currentClass.id,
            type: 'quiz',
            canvas_course_id: currentClass.canvas_course_id,
            canvas_section_id: currentClass.canvas_id,
            internal_assignment_id: internalAssignmentId
          };
          const deepLinkAssignmentData = {
            ...quizData,
            redirect_path: deepLinkConfig.redirect_path,
            redirect_class_id: deepLinkConfig.redirect_class_id,
            redirect_assignment_id: deepLinkConfig.redirect_assignment_id
          };
          const deepLinkResult = await dispatch(handleCreateCanvasAssignmentDeepLink(
            currentUser.canvas_id,
            [assignmentData],
            currentUser.canvas_auth_id,
            deepLinkAssignmentData
          ));
          if (deepLinkResult && deepLinkResult.isDeepLinking) {
            showAlert("Activity selected and linked to Canvas.", "success");
          } else {
            showAlert("Pending activity created. You can sync it later.", "success");
          }
        } else {
          showAlert("Failed to create pending activity. Please try again.", "error");
        }
      } catch (error) {
        console.error('Error creating pending activity:', error);
        showAlert("Error creating pending activity. Please try again.", "error");
      }
      toggleQuizDrawer(false);
      setDataLoading(false);
      setQuizData({});
      return;
    }
    const hasMultipleAssignments = quizDataForCreate.selectedAssignments && quizDataForCreate.selectedAssignments.length > 1;
    const integrationQuizDataForCreate = filterPayloadForIntegrationCreate(
      quizDataForCreate,
      alreadyAssignedByAssignmentId
    );
    
    if (currentUser.googleId) {
      await dispatch(handleCreateClassQuizGoogle(integrationQuizDataForCreate, currentUser.googleId));
      await dispatch(handleListClassQuizzes(currentClass.id));
    } else if (currentUser.schoologyid && hasMultipleAssignments) {
      await dispatch(handleCreateClassQuizSchoology(integrationQuizDataForCreate, currentUser.schoologyid));
      await dispatch(handleListClassQuizzes(currentClass.id));
    } else {
      if (!currentUser.schoologyid || !hasMultipleAssignments) {
        const sAssignmentData = await createAssignmetToSchoologyMultipleClass(
          integrationQuizDataForCreate
        );
        if (sAssignmentData && sAssignmentData.length > 0) {
          quizDataForCreate.sAssignmentData = sAssignmentData;
          quizDataForCreate?.selectedAssignments?.forEach((assignment) => {
            const assignmentSchoologyData = sAssignmentData.filter((schoologyItem) => schoologyItem.assignmentId === assignment.id);
            assignment.sAssignmentData = assignmentSchoologyData;
          });
        }
      }
      
      const canvasData = await createAssignmetToCanvasMultipleClass(
        integrationQuizDataForCreate
      );
      if (canvasData && canvasData.length > 0) {
        quizDataForCreate.canvasData = canvasData;
      }
      
      if (!currentUser.googleId) {
        await dispatch(handleCreateClassQuiz(quizDataForCreate));
        await dispatch(handleListClassQuizzes(currentClass.id));
      }
    }
    if (isScheduledToday(quizData?.scheduleAt)) {
      await sendBatchNotifications(notificationsData);
    }
    toggleQuizDrawer(false);
    setDataLoading(false);
    setQuizData({});
  };
  const updateActivityData = (id, value) => {
    setActivityData(prevState => ({
      ...prevState,
      [id]: value
  }));
  };

  const updateQuizData = (id, value) => {
    setQuizData(prevState => ({
      ...prevState,
      [id]: value
  }));
  };

  const handleClose = () => {
    setReviewDialog({ open: false, message: '' });
  };

  const handleClick = async () => {
    if(isBookNotAssignable && !isExam) {
      showAlert("Book is not available for students, Assignments cannot be assign", "info");
      return;
    }
    else if(isBookHidden) {
      showAlert("Book is hidden, Assignments cannot be assign", "info");
      return;
    }
    if (handleForDistrictAdmin()) return;
    if (isReviewAccount) {
      setReviewDialog({ open: true, message: 'Only for Review!' });
      return;
    }

    if (
      assignment?.createdBy !== currentUser?.id &&
      AssignmentShareList?.includes(currentUser?.id) &&
      assignment?.type === 'custom'
    ) {
      const { id, ...remainingAssignment } = assignment;
      const data = {
        ...remainingAssignment,
        createdBy: currentUser?.id,
        share_list: [],
        cloneId: assignment?.id,
      };
      setAssignLoader(true);
      const updatedData = await dispatch(handleCreateCustomAssignment(data));
      setAssignLoader(false);
      if (updatedData?.typeId === 'activity') {
        if (isExternalToolMode) {
          const deepLinkInfo = getDeepLinkInfo();
          setDeepLinkConfig({
            ...deepLinkInfo,
            redirect_path: window.location.pathname + window.location.search,
            redirect_class_id: currentClass.id,
            redirect_assignment_id: updatedData.id
          });
        }
        toggleActivityDrawer(true);
        setActivityData(updatedData);
      } else {
        if (isExternalToolMode) {
          const deepLinkInfo = getDeepLinkInfo();
          setDeepLinkConfig({
            ...deepLinkInfo,
            redirect_path: window.location.pathname + window.location.search,
            redirect_class_id: currentClass.id,
            redirect_assignment_id: updatedData.id
          });
        }
        toggleQuizDrawer(true);
        setQuizData(updatedData);
      }
    } else {
      if (assignment?.typeId === 'activity') {
        if (isExternalToolMode) {
          const deepLinkInfo = getDeepLinkInfo();
          setDeepLinkConfig({
            ...deepLinkInfo,
            redirect_path: window.location.pathname + window.location.search,
            redirect_class_id: currentClass.id,
            redirect_assignment_id: assignment.id
          });
        }
        toggleActivityDrawer(true);
        setActivityData(assignment);
      } else {
        if (isExternalToolMode) {
          const deepLinkInfo = getDeepLinkInfo();
          setDeepLinkConfig({
            ...deepLinkInfo,
            redirect_path: window.location.pathname + window.location.search,
            redirect_class_id: currentClass.id,
            redirect_assignment_id: assignment.id
          });
        }
        toggleQuizDrawer(true);
        setQuizData(assignment);
      }
    }
  };

  const createAssignmentsForGoogleClassRoom = async (assignment) => {
    try {
      if (!currentUser.googleId) return [];
      if (assignment.no_sync) return [];
      
      const selectedAssignments = assignment.selectedAssignments || [];
      const allGooglePromises = [];
      
      for (const assignmentData of selectedAssignments) {
        const classPromises = map(assignment.classes, async (cls) => {
          const classInfo = find(userClasses, ['id', cls.id]);
          if (classInfo && classInfo.googleId) {
            const assignmentPayload = {
              ...assignmentData,
              displayName: assignmentData.displayName || assignmentData.title,
              dueDate: currentClass.id === cls.id ? assignment.dueDate : cls.dueDate,
              assignmentId: assignmentData.id,
              assignmentDisplayName: assignmentData.displayName || assignmentData.title
            };
            
            const createdAssignment = await handleCreateGoogleAssignment(
              currentUser.googleId,
              assignmentPayload,
              classInfo.googleId
            );
            
            return {
              classId: classInfo.id,
              googleAssignmentId: get(createdAssignment, 'id'),
              assignmentId: assignmentData.id,
              assignmentDisplayName: assignmentData.displayName || assignmentData.title
            };
          }
          return null;
        });
        
        allGooglePromises.push(...classPromises);
      }
      
      return Promise.all(allGooglePromises).then((v) => v.filter((k) => k));
    } catch (error) {
      console.error("Error creating Google Classroom assignments:", error);
      Sentry.captureException(`138 Error during Google Classroom assignment creation ${error}.`);
      return [];
    }
  };
  const isDefaultDueDate = (d) => {
    if (!d) return false;
    const today1159 = moment().hour(23).minute(59).second(0).millisecond(0);
    return moment(d).isSame(today1159, 'minute');
  };

  const createAssignmetToSchoologyMultipleClass = async (quizeDataforCreate) => {
    if(quizeDataforCreate.no_sync) return [];
    
    const selectedAssignments = quizeDataforCreate.selectedAssignments || [];
    const hasClass = filter(quizeDataforCreate?.classes, (e) => e?.sectionId);
    
    if (hasClass.length === 0) return [];
    
    const assignment_data = [];
    
      for (const assignmentData of selectedAssignments) {
      for (const item of hasClass) {
        const schoologyCategory = item.schoologyCategory
          ? item.schoologyCategory
          : quizeDataforCreate.schoologyCategory;
        const rawDue = item.id === currentClass.id ? quizeDataforCreate.dueDate : item.dueDate;
        const dueDate = (item.id !== currentClass.id && isDefaultDueDate(item.dueDate)) ? quizeDataforCreate.dueDate : rawDue;
        let data = {
          title: assignmentData.displayName || assignmentData.title,
          description: assignmentData.displayName || assignmentData.title,
          due: `${dueDate}`,
          type: 'assignment',
          assignees: [`${currentUser.schoologyid}`],
          grading_group_ids: [],
          grading_category: schoologyCategory,
          section_id: item.sectionId,
          classId: item.id,
          maxPoints: item.maxPoints || 100,
          factor: item.factor,
          assignmentId: assignmentData.id,
          assignmentDisplayName: assignmentData.displayName || assignmentData.title,
          system_timezone: getSystemTimezone()
        };
        assignment_data.push(data);
      }
    }
    
    const create_data = await handleCreateAssignmentToSchoology(currentUser.schoologyid, assignment_data);
    return create_data;
  };
  const createAssignmetToCanvasMultipleClass = async (quizeDataforCreate) => {
    if (!get(currentUser, 'canvas_id') || !quizeDataforCreate) return [];
    if(quizeDataforCreate.no_sync) return [];
    
    const selectedAssignments = quizeDataforCreate.selectedAssignments || [];
    const allAssignmentsForCanvas = [];
    
    for (const assignmentData of selectedAssignments) {
      const hasClass = map(quizeDataforCreate?.classes, (e) => {
        const rawDue = e.id === currentClass.id ? quizeDataforCreate.dueDate : e.dueDate;
        const dueDate = (e.id !== currentClass.id && isDefaultDueDate(e.dueDate)) ? quizeDataforCreate.dueDate : rawDue;
        const userClass = find(userClasses, ['id', e.id]);
        return {
          ...e,
          class_id: e.id,
          due_date: dueDate,
          weightage: quizeDataforCreate.weightage
            ? quizeDataforCreate.weightage
            : '100',
          displayName: assignmentData.displayName || assignmentData.title,
          canvas_section_id: get(userClass, 'canvas_id'),
          canvas_course_id: get(userClass, 'canvas_course_id'),
          canvas_assignment_catrgory: e.canvas_assignment_catrgory,
          grade_type: quizeDataforCreate.grade_type,
          max_point: quizeDataforCreate.max_point,
          final_grade_exclude: quizeDataforCreate.final_grade_exclude,
          unlock_at: quizeDataforCreate?.scheduleAt,
          assignmentId: assignmentData.id,
          assignmentDisplayName: assignmentData.displayName || assignmentData.title
        };
      });
      
      allAssignmentsForCanvas.push(...hasClass);
    }
    
    if (allAssignmentsForCanvas.length === 0) return [];
    
    try {
      const createdAssignments = await handleCreateCanvasAssignment(
        currentUser.canvas_id,
        allAssignmentsForCanvas,
        currentUser.canvas_auth_id
      );
      
      const allCanvasResults = map(createdAssignments, (q) => {
        if (q && q.canvas_course_id) {
          const classInfo = find(
            userClasses,
            (uc) => uc.canvas_id == q.canvas_section_id
          );
          return {
            canvas_section_id: q.canvas_section_id,
            canvas_course_id: q.canvas_course_id,
            canvas_assignment_id: q.id,
            classId: get(classInfo, 'id'),
            assignmentId: q.assignmentId,
            assignmentDisplayName: q.assignmentDisplayName
          };
        }
        return null;
      }).filter((q) => q);
      
      return allCanvasResults;
    } catch (error) {
      console.error('Error creating Canvas assignments:', error);
      Sentry.captureException(`Error creating Canvas assignments: ${error}`);
      return [];
    }
  };
  const onCloseDrawer = () => {
    toggleQuizDrawer(false);
    toggleActivityDrawer(false);
    setQuizData({});
    setActivityData({});
    setDataLoading(false);
    setDurationSection(false);
  };
  const deleteCustomAssignment = async () => {
    setDeleteLoading(true);
    if (editCustomAssignmentData && editCustomAssignmentData.createdBy !== currentUser.id) {
      await dispatch(
        handleUnhareToMe(get(editCustomAssignmentData, "id"), currentUser.id)
      );
      setDeleteLoading(false);
      setDeleteModal(false);
      setEditCustomAssignmentData({});
    } else {
      await dispatch(
        handleDeleteCustomAssignment(get(editCustomAssignmentData, 'id'))
      );
      setDeleteLoading(false);
      setDeleteModal(false);
      setEditCustomAssignmentData({});
    }
  };
  const onEditAssignment = async () => {
    if (handleForDistrictAdmin()) return;
    if (
      assignment?.createdBy !== currentUser?.id &&
      AssignmentShareList?.includes(currentUser?.id) &&
      assignment?.type === 'custom'
    ) {
      const { id, ...remainingAssignment } = assignment;
      const data = {
        ...remainingAssignment,
        createdBy: currentUser?.id,
        share_list: [],
        cloneId: assignment?.id,
      };
      const updatedData = await dispatch(handleCreateCustomAssignment(data));
      setEditCustomAssignmentModal(true);
      const assignmentData =
        get(updatedData, 'type') === 'custom'
          ? updatedData
          : omit(updatedData, 'id');
      if (get(updatedData, 'type') !== 'custom') {
        assignmentData.cloneId = get(updatedData, 'id');
      }
      setEditCustomAssignmentData(assignmentData);
    } else {
      setEditCustomAssignmentModal(true);
      const assignmentData =
        get(assignment, 'type') === 'custom'
          ? assignment
          : omit(assignment, 'id');
      if (get(assignment, 'type') !== 'custom') {
        assignmentData.cloneId = get(assignment, 'id');
      }
      setEditCustomAssignmentData(assignmentData);
    }
  };

  const handleClickAiAnswer = async (answerData) => {
    if (checkPopUpAtOnce()) return;
    invokeAiAnswerView(answerData);
    updatePopUpAtOnce(true);
  }

  const isDisabled = false;

  const autoScrollhandled = () => {
    handleClickAiAnswer(assignment);
    try {
      
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      document.body.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    } catch (error) {
      Sentry.captureException(`139 Error in autoScrollhandled: ${error}`);
    }
  }


  const getAssignableAction = (className) => {
    return(
      <div className='assignableActionCstm 111'>
        
        {get(assignment, 'type') === 'custom' ? (
          <IconButton
            color='error'
            style={{ padding: 0 }}
            onClick={() => {
              setDeleteModal(true);
              setEditCustomAssignmentData(assignment);
            }}
          >
            <img src={trashIconSvg} className='trashIcon' alt="" title="" />
          </IconButton>
        ) : (
          <div></div>
        )}

        {assignment?.activity_type!='graphic_organizer'? from !== "extensionActivity" ?  <IconButton
          color='primary'
          style={{ padding: 0 }}
          onClick={onEditAssignment}
        >
          <Tooltip placement='top' title="Editar preguntas">
            <img src={customEditSvg} alt="" title="" />
          </Tooltip>
        </IconButton>:null: null}

        <PrintPage data={assignment}/>

      </div>
    )
  }
  
  return (
    <SentryWrap>
      <>
      <SpinLoader dataloader={pendingActivityLoading} />
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={openReviewDialog.open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity='error'>
          <strong>ALERT:</strong> {openReviewDialog.message}
        </Alert>
      </Snackbar>
      <DeleteModal
        message={`Are you sure you want to delete? You will lose all submissions and grades for this assignment.`}
        deleteToggle={deleteModal}
        setDeleteToggle={setDeleteModal}
        loading={deleteLoading}
        onDelete={deleteCustomAssignment}
      />
      {cloneToPageOpen && <CloneActivityToPageModal
        open={cloneToPageOpen}
        onClose={() => setCloneToPageOpen(false)}
        assignment={assignment}
      />}
      {editCustomAssignmentModal && <AssignmentForm
        bookId={get(editCustomAssignmentData, 'chapter')}
        pageId={get(editCustomAssignmentData, 'page')}
        open={editCustomAssignmentModal}
        data={editCustomAssignmentData}
        onClose={() => {
          setEditCustomAssignmentModal(false);
          setEditCustomAssignmentData({});
        }}
      />}
      <Drawer
        height='100%'
        destroyOnHidden
        onClose={onCloseDrawer}
        placement='top'
        open={quizDrawer}
        key='quizNew'
        className='assignments-drawer'
      >
        <>
          <QuizForm
            data={quizData}
            handleChange={(e) => updateQuizData(e.target.id, e.target.value)}
            handleSubmit={createQuiz}
            setDurationSection={setDurationSection}
            durationSection={durationSection}
            loading={dataLoading}
            onClose={() => toggleQuizDrawer(false)}
            handleRubric={(value)=> {
              setFetchRubricId(value?.id || "")
            }}
          />
        </>
      </Drawer>
      <Drawer
        height='100%'
        destroyOnHidden
        onClose={onCloseDrawer}
        placement='top'
        open={activityDrawer}
        key='activityNew'
        className='assignments-drawer'
      >
        <>
          <ActivityForm
            data={activityData}
            handleChange={(e) =>
              updateActivityData(e.target.id, e.target.value)
            }
            handleSubmit={createActivity}
            setDurationSection={setDurationSection}
            durationSection={durationSection}
            onClose={() => toggleActivityDrawer(false)}
            handleRubric={(value)=> {
              setFetchRubricId(value?.id || "")
            }}
          />
        </>
      </Drawer>
      {/* <Wrapper
                bgColor={assignmentColor}
                borderColor={null}
                hoverColor={assignmentColor}
            >
                <Row align="flex-start">
                    <Col span={20} style={{ display: "flex", flexDirection: "row", alignItems: 'center',marginBottom:20,marginTop:5 }}>
                        {assignment?.typeId === 'activity'
                            ? <img style={{ width: 24, marginRight: 4 }} id='debade_icon' src={editIcons} alt="Student activity" title='Student activity' />
                            // <Extension style={{ height: '18px', marginRight: '4px' }} />
                            : <Assignment style={{ height: '18px', marginRight: '4px' }} />
                        }
                        <Title style={{color:'black',fontWeight:'500'}}>{get(assignment, "displayName", "")}</Title>
                    </Col>
                    <Col span={4} style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        {get(assignment, "type") === "custom" && (
                            <>
                                
                                <IconButton color='error'
                                    style={{ padding: 0 }}
                                    onClick={() => {
                                        setDeleteModal(true)
                                        setEditCustomAssignmentData(assignment)
                                    }}>
                                    <Delete color="error" />
                                </IconButton>
                            </>
                        )}
                        <IconButton color='primary'
                            style={{ padding: 0 }}
                            onClick={onEditAssignment}>
                            <Edit style={{color:'black'}} />
                            
                        </IconButton>
                    </Col>
                </Row>
                {bookDescription ? <BookDescRow><strong>Book</strong>: {bookDescription}</BookDescRow> : null}
                <Row style={{ flexDirection: "row", alignItems: 'center', justifyContent: 'flex-start', marginBottom: 8 }}>
                    <Column style={{ flexDirection: "row", alignItems: 'center', justifyContent: 'space-between', background: '#0d2e6d', padding: '1.5px 10px 1.5px 10px', borderRadius: 7,marginRight:12 }}>
                        <Text style={{ color: 'white',fontSize:12 }}>Status: <strong style={{ color: 'white' }}>Unassigned</strong></Text>
                    </Column>
                    <TextLarge style={{ display: 'flex', alignItems: 'center',marginRight:12 }} onClick={onPreviewCick}>
                        Preview</TextLarge>
                    <TextLarge style={{ display: 'flex', alignItems: 'center',marginRight:12 }} onClick={handleClick}>
                        Assign Now</TextLarge>
                </Row>
                <Row style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end',marginBottom:1 }}>
                    <TextLarge style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }} onClick={handleClick}>
                        Share with other teachers
                    </TextLarge>
                </Row>
                <Row style={{ position: 'absolute', top: -16,left:0 }}>
                    <TextLarge style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', color: 'white', backgroundColor: '#166c17',padding:'1.5px 10px',borderRadius:7 }}>
                        Shared by iris cordova
                    </TextLarge>
                </Row>
                <Row style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginBottom: 1 }}>
                    <TextLarge  style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }} onClick={handleClick}>
                        {assignment?.createdBy === currentUser?.id && <AssignableNotificationShare assignment={assignment} />}
                    </TextLarge>
                </Row>
                <Row style={{ position: 'absolute', top: -16, left: 0 }}>
                    <TextLarge style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', color: 'white', backgroundColor: '#166c17', padding: '1.5px 10px', borderRadius: 7 }}>
                        Shared by iris cordova
                    </TextLarge>
                </Row>
            </Wrapper> */}

      {/* <Wrapper
        style={{ paddingRight: '25px', paddingLeft: '13px' }}
        bgColor={assignmentColor}
        borderColor={null}
        hoverColor={assignmentColor}
      >
        {assignment?.share_by !== currentUser?.id &&
          Object.keys(fetchShareBy).length > 0 && (
            <SharedAndAssignedTask
              sharedBy={`${fetchShareBy?.firstName} ${fetchShareBy?.lastName}`}
              isAssignedActive={false}
              isSharedActive={true}
            />
            // <Row align="flex-start">
            //   <TextLarge
            //     style={{
            //       display: "flex",
            //       alignItems: "center",
            //       justifyContent: "flex-end",
            //       color: "white",
            //       backgroundColor: "#166c17",
            //       padding: "1.5px 10px",
            //       borderRadius: 7,
            //     }}
            //   >
            //     {`Shared by ${fetchShareBy?.firstName} ${fetchShareBy?.lastName}`}
            //   </TextLarge>
            // </Row>
          )}
        <Row align='center' style={{ justifyContent: 'space-between' }}>
          <Col
            span={20}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 20,
              marginTop: 5,
            }}
          >
            {assignment?.typeId === 'activity' ? (
              <img
                style={{ width: 12, marginRight: 9 }}
                id='debade_icon'
                src={IsolationMode}
                alt='Student activity'
                title='Student activity'
              />
            ) : (
              
              <Assignment style={{ height: '18px', marginRight: '4px' }} />
            )}
            <Title className='assigned-task-name'>
              {get(assignment, 'displayName', '')}
            </Title>
          </Col>
          <Row
            
            style={
              {
                
              }
            }
          >
            {get(assignment, 'type') === 'custom' ? (
              <IconButton
                color='error'
                style={{ padding: 0, marginRight: '7px' }}
                onClick={() => {
                  setDeleteModal(true);
                  setEditCustomAssignmentData(assignment);
                }}
              >
                <Delete color='error' />
              </IconButton>
            ) : (
              <div></div>
            )}
            <IconButton
              color='primary'
              style={{ padding: 0 }}
              onClick={onEditAssignment}
            >
              <Edit style={{ color: 'black' }} />

            </IconButton>
          </Row>
        </Row>
        {bookDescription ? (
          <BookDescRow>
            <strong>Book</strong>: {bookDescription}
          </BookDescRow>
        ) : null}

        <Row
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
            marginBottom: 8,
          }}
        >
          <Column
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-start',
              marginLeft: 0,

             
            }}
          >
            <Text className='assignable-status-text'>
              Status: <strong className='assignable-value'>Unassigned</strong>
            </Text>
          </Column>
        </Row>
        <Row
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          {assignment?.createdBy === currentUser?.id && (
            <AssignableNotificationShare assignment={assignment} />
          )}

          <TextLarge
            className='preview-edit-text'
            style={{ display: 'flex', alignItems: 'center' }}
            onClick={onPreviewCick}
          >
            Preview |
          </TextLarge>
          <TextLarge
            className='preview-edit-text'
            style={{ display: 'flex', alignItems: 'center' }}
            onClick={handleClick}
          >
            &nbsp;Assign Now
          </TextLarge>
        </Row>
      </Wrapper> */}
      {isExam ? (
        <ExamAssignmentWrapper className={`examAssignmentWrapCstm ${isUnitExam ? 'addUnitCstm' : ''} ${assignment?.is_exam ? 'addAssignExamCstm' : ''}`}
          bgColor={assignmentColor}
          borderColor={null}
          hoverColor={assignmentColor}
          isUnitExam={isUnitExam}
          isExam={assignment?.is_exam}
        >
            
          <div className='cardlabelSet' 
          style={{  color: isUnitExam ? '#43969C' : assignment?.is_exam ? 'white' : '#43969C' }}
          >
            {isUnitExam ? 
            <span className="assignmentLabel" style={{ color: isUnitExam ? '#43969C' : assignment?.is_exam ? 'white' : '#43969C'}}>EXAMEN DE UNIDAD</span> 
            : assignment?.is_exam ? 
            <span className="assignmentLabel" style={{ color: isUnitExam ? '#43969C' : assignment?.is_exam ? 'white' : '#43969C'}}>PRUEBA</span> : null}
          </div>
         
          <div className='assignmentCstmName unitExam assignmentNameFlex'>
            <div className='assignmentFlexLft'>
              {assignment?.typeId === 'activity' ? (
                <img src={titleIconSvg} alt="" title="" />
              ) : (
                <img src={titleIconSvg} alt="" title="" />
              )}
              <Tooltip placement='top' title={get(assignment, 'displayName', '')}>
                <Title className='assigned-task-name text-wrap 121212'>
                  {get(assignment, 'displayName', '')}
                </Title>
              </Tooltip>
            </div>

            <div className='assignmentFlexRght'>
                <PrintPage data={assignment} isUnitExam={isUnitExam}  isExam={assignment?.is_exam} />
                {assignment?.createdBy === currentUser?.id && (
                  <AssignableNotificationShare
                    assignment={assignment}
                    exameshare={false}
                  />
                )}
                {get(assignment, 'type') === 'custom' ? (
                  <IconButton
                    className='editCustomize'
                    color='error'
                    style={{ padding: 0 }}
                    onClick={() => {
                      setDeleteModal(true);
                      setEditCustomAssignmentData(assignment);
                    }}
                  >
                    <Tooltip placement='top' title="Delete">
                     <Delete color='error' style={{ fontSize: '23px' }} />
                    </Tooltip>
                  </IconButton>
                ) : (
                  <></>
                )}  
            </div>
          </div>

          <div className='11 assignNotifyUpr'>
          <div className='assignNotifyLft'>
            <>
            {bookDescription ? (
                <div className='cardDetail'>
                  <div className='cardDetailInr'>
                  <img src={lastSubSvg} alt="" title="" />
                  <p>Book:</p>
                  </div>
                  <span>{bookDescription}</span>
              </div>
              ) : null}
            </>

            <div className='cardDetail 1333'>
              <div className='cardDetailInr'>
                <img src={statusSvg} alt="" title="" />
                <p>Status:</p>
              </div>
              <div className="assigned-class-text">
                Unassigned
              </div>
            </div>

            
          </div>

          {/* <div className='assignNotifyRght'><img src={dummyImage2Svg}  width="" height={""} alt="" className='dummyImagePlace' /></div> */}
          <div className='assignNotifyRght'>
          <img
              src={modalSrc}
              width=''
              height={''}
              alt=''
            />
          </div>
          </div>

          <div
            className={`sharedAssignedTask sharedTaskInActv ${
              assignment?.share_by !== currentUser?.id &&
              Object.keys(fetchShareBy).length > 0
                ? ''
                : 'sharedTaskRmvSpc'
            }`}>

            {assignment?.share_by !== currentUser?.id &&
            Object.keys(fetchShareBy).length > 0 && (
              <ExamsSharedAndAssignedTask
                sharedBy={`${fetchShareBy?.firstName} ${fetchShareBy?.lastName}`}
                isAssignedActive={false}
                isSharedActive={true}
                isUnitExam={isUnitExam}
                styles={{ right: assignment?.is_ai ? 20 : 0 }}
              />
            )}
          <div style={{ display: 'flex', alignItems: 'center'}}>
            {assignment?.data?.is_ai && (
             <div className='assignAi'><img src={AssignmentAi} alt='Assignment Ai' /></div>
            )}
            {storyInstructionView ? <ShowStoryBtn storyInstruction={storyInstructionView} /> : null}
          </div>
          </div>

          <div className='switchCollectUpr 123'>
              <div className='switchCollecLeft'>

                <button className='asignarBtnCstm' onClick={handleClick} disabled={pendingActivityLoading}>
                  {pendingActivityLoading ? 'Loading...' : (isExternalToolMode ? 'Select' : 'Asignar')}
                </button>

                {assignment?.is_ai &&   (
                <div className='verResBtn addCursor' 
                  onClick={() => handleClickAiAnswer(assignment)}><span>Respuestas</span>
                </div>
                )}

                {/* {assignment?.createdBy === currentUser?.id && (
                  <AssignableNotificationShare
                    assignment={assignment}
                    exameshare={false}
                  />
                )} */}

                {/* <Tooltip placement='top' title="Asignar">
                  <img src={assignerSvg} alt="" title="" onClick={handleClick} />
                </Tooltip> */}

                {/* <PrintPage data={assignment} /> */}

                <Tooltip placement='top' title="Preview">
                  <div className={`iconLabel ${isTablate? "labelVisibleIconForSmallDeviceTablet" : "labelVisibleIconForSmallDevice"}`} onClick={onPreviewCick}>
                    <img src={eyeBtnSvg} alt="" title="" />
                    <label className={`${isTablate? "lablesNonVisibleOnSmallDeviceTablet" : "lablesNonVisibleOnSmallDevice"} `}>Preview</label>
                  </div>
                </Tooltip>

                {assignment?.activity_type!='graphic_organizer'?
                 <Tooltip placement='top' title="Editar preguntas">
                   <div className={`iconLabel ${isTablate? "labelVisibleIconForSmallDeviceTablet" : "labelVisibleIconForSmallDevice"}`} onClick={onEditAssignment}>
                    <img src={customEditSvg} onClick={onEditAssignment} alt="" title="" />
                    <label className={`${isTablate? "lablesNonVisibleOnSmallDeviceTablet" : "lablesNonVisibleOnSmallDevice"} `}>Editar preguntas</label>
                   </div>
                  </Tooltip>
                :null}

                {showCopyToBookPage ? (
                  <Tooltip placement='top' title={copyToBookPageTooltipTitle}>
                    <div className='iconLabel' onClick={() => setCloneToPageOpen(true)}>
                      <label><CopyAllOutlined /></label>
                    </div>
                  </Tooltip>
                ) : null}
               
              </div>
              
            </div>
            

        </ExamAssignmentWrapper>
      ) : 
      assignment?.typeId === 'worksheet' ? (
        <div style={{ marginTop: '12px' }}>
          <WorksheetAssignment worksheetData={worksheetData} ActivityData={assignment} page={assignment?.page} bookId={assignment?.chapter} numberMasked={assignment?.numberMasked} pageLearningModuleCount={assignment?.pageLearningModuleCount} />
        </div>
       ) : (
        <Wrapper
          style={{ position: 'relative' }}
          bgColor={assignmentColor}
          borderColor={null}
          hoverColor={assignmentColor}
          isGeneratedTest={isGeneratedTest}
          className={`cardTextWraper${isGeneratedTest ? ' addGeneratedTestCstm' : ''}`}
        >
          <div className="cardlabelSet">
            <span className="assignmentLabel">{isGeneratedTest?"ACTIVIDAD GENERADA":"ACTIVIDAD"}</span>
          </div>

          <div className='assignmentCstmName assignmentNameFlex'>
            <div className='assignmentFlexLft'>
              {assignment?.typeId === 'activity' ? (
                <img src={nonAssignSvg} alt="" title="" />
              ) : (
                <img src={assignSvg} alt="" title="" />
              )}
              <Tooltip placement='top' title={get(assignment, 'displayName', '')}>
                <Title className='assigned-task-name text-wrap'>
                  {get(assignment, 'displayName', '')}
                </Title>
              </Tooltip>
            </div>

            <div className='assignmentFlexRght 232323'>
             <PrintPage data={assignment} isGeneratedTest={isGeneratedTest} />

             {assignment?.createdBy === currentUser?.id && (
              <AssignableNotificationShare assignment={assignment} />
             )}

             {get(assignment, 'type') === 'custom' ? (
              <IconButton
                color='error'
                style={{ padding: 0 }}
                onClick={() => {
                  setDeleteModal(true);
                  setEditCustomAssignmentData(assignment);
                }}>
                <img src={trashIconSvg} className='trashIcon' alt="" title="" />
                </IconButton>
                ) : (
                <></>
               )}
            </div>
          </div>

         <div className='22 assignNotifyUpr'>
          <div className='assignNotifyLft'>

           <div className='cardDetail'>
            <div className='cardDetailInr'>
              <img src={statusSvg} alt="" title="" />
              <p>Status:</p>
            </div>
            <div className="assigned-class-text">
              Unassigned
            </div>
           </div>

           <>
           {bookDescription ? (
              <div className='cardDetail'>
                <div className='cardDetailInr'>
                 <img src={lastSubSvg} alt="" title="" />
                 <p>Book:</p>
                </div>
                <span>{bookDescription}</span>
            </div>
            ) : null}
          </>
          
           
          </div> 

          <div className='assignNotifyRght'>
          <img
              src={modalSrc}
              width=''
              height={''}
              alt=''
            />
            {/* <img src={dummyImageSvg} alt="" title="" className='dummyImagePlace' /> */}
          </div>
          
        </div> 

        <div
            className={`sharedAssignedTask sharedTaskInActv ${
              assignment?.share_by !== currentUser?.id &&
              Object.keys(fetchShareBy).length > 0
                ? ''
                : 'sharedTaskRmvSpc'
            }`}>
            {assignment?.share_by !== currentUser?.id &&
             Object.keys(fetchShareBy).length > 0 && (
              <SharedAndAssignedTask
                sharedBy={`${fetchShareBy?.firstName} ${fetchShareBy?.lastName}`}
                isAssignedActive={false}
                isSharedActive={true}
              />
            )}
            <div style={{ display: 'flex', alignItems: 'center'}}>
              {assignment?.is_ai && (
                 <div className='assignAi'><img src={AssignmentAi} alt='Assignment Ai' /></div>
              )}
              {storyInstructionView ? <ShowStoryBtn storyInstruction={storyInstructionView} /> : null}
            </div>
          </div> 

        <div className='switchCollectUpr'>

          <div className='switchCollecLeft 111'>

          {assignment?.is_ai &&   (
            <div className='verResBtn addCursor' 
            onClick={() => {
              autoScrollhandled();
            }}>
             <span>Respuestas</span>
            </div>
          )}
          
            {/* {assignment?.createdBy === currentUser?.id && (
              <AssignableNotificationShare assignment={assignment} />
            )} */}

           {/* <Tooltip placement='top' title="Asignar">
            <img src={assignerSvg} alt="" title="" 
              onClick={() => {
                if (Assignloader) return;
                handleClick();
              }}
            />
           </Tooltip> */}

           <button className='asignarBtnCstm' onClick={() => { if (Assignloader || pendingActivityLoading) return; handleClick(); }} disabled={pendingActivityLoading || Assignloader}>
             {pendingActivityLoading ? 'Loading...' : (isExternalToolMode ? 'Select' : 'Asignar')}
           </button>

            {/* <PrintPage data={assignment}/> */}

            <Tooltip placement='top' title="Preview" onClick={onPreviewCick}>
              <div className={`iconLabel ${isTablate? "labelVisibleIconForSmallDeviceTablet" : "labelVisibleIconForSmallDevice"}`}>
               <img src={eyeBtnSvg} alt="" title="" />
               <label className={`${isTablate? "lablesNonVisibleOnSmallDeviceTablet" : "lablesNonVisibleOnSmallDevice"} `}>Preview</label>
              </div>
            </Tooltip>

            {assignment?.activity_type!='graphic_organizer'? <IconButton
              color='primary'
              style={{ padding: 0 }}
              onClick={onEditAssignment}>
              <Tooltip placement='top' title="Editar preguntas" trigger="hover">
                <div className={`iconLabel ${isTablate? "labelVisibleIconForSmallDeviceTablet" : "labelVisibleIconForSmallDevice"}`}>
                 <img src={customEditSvg} alt="" title="" />
                 <label className={`${isTablate? "lablesNonVisibleOnSmallDeviceTablet" : "lablesNonVisibleOnSmallDevice"} `}>Editar preguntas</label>
                </div>
              </Tooltip>
            </IconButton>:null}
            {showCopyToBookPage ? (
              <Tooltip placement='top' title={copyToBookPageTooltipTitle}>
                <div className='iconLabel' onClick={() => setCloneToPageOpen(true)}>
                  <CopyAllOutlined/>
                </div>
              </Tooltip>
            ) : null}
          </div>

        </div>

        </Wrapper>
      )}
      </>
    </SentryWrap>
  );
};

const mapStateToProps = (state) => ({
  currentClass: state.currentClass,
  booksAllList: state.booksAllList,
  currentUser: state.currentUser,
});

export default connect(mapStateToProps, null)(AssignableNotification);


